import axios from 'axios'
import { APIResponse } from '../../../types/api/api-response'
import { SEO_PATH } from '../../../types/api/seo-properties'
import { SeoProperties } from '../../../types/model/seo'

const baseHeader = {
  Authorization: `Basic ${process.env.CMS_BUKABANGUNAN_SECRET}`,
}

export const seoPropertiesClient = {
  retrieveSEOProperties: (pageKey: string) =>
    axios.get<APIResponse<SeoProperties>>(`${SEO_PATH}/${pageKey}`, { headers: baseHeader }),
}
